import React, {useState, useEffect} from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Snackbar,
    Alert
} from '@mui/material';
import {MdPersonOutline} from "react-icons/md";
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import './VacationPopup.css';
import {ka} from "date-fns/locale";
import DatePicker from "react-datepicker";

const VacationPopup = ({open, onClose, users, userId, onNewVacation, vacationUsers}) => {
    const [selectedUserId, setSelectedUserId] = useState('');
    const [vacationStartDate, setVacationStartDate] = useState(null);
    const [vacationEndDate, setVacationEndDate] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const activeVacationUsers = vacationUsers.filter(vacationUser => vacationUser.isActive)


    useEffect(() => {
        if (!open) {
            setVacationStartDate(null);
            setVacationEndDate(null);
        }
    }, [open]);

    useEffect(() => {
        if (vacationStartDate && vacationEndDate && vacationStartDate < vacationEndDate) {
            setSubmitDisabled(false);

        } else if (vacationStartDate === null && vacationEndDate === null) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [vacationStartDate, vacationEndDate]);

    const getUserById = (usersList, userId) => {
        const user = usersList.find(user => user.id === userId);
        return user ? `${user.firstName} ${user.lastName} (${rolesInGeorgian[user.roleName]})` : "დაფიქსირდა შეცდომა!";
    };

    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };

    const handleUserChange = (event, value) => {
        setSelectedUserId(value ? value.id : '');
    };

    const handleSubmit = async () => {
        const adjustedStartDate = vacationStartDate
            ? new Date(vacationStartDate)
            : new Date();
        adjustedStartDate.setDate(adjustedStartDate.getDate() + 1);


        const adjustedEndDate = vacationEndDate
            ? new Date(vacationEndDate)
            : new Date('2100-01-01');
        adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);



        const payload = {
            temporaryExecutorUserId: selectedUserId,
            onVacationUserId: userId,
            vacantionEndDate: adjustedEndDate,
            vacantionStartDate: adjustedStartDate
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewVacantion`, payload);

            if (response.data.success) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertSeverity('success');
                setAlertOpen(true);
                onNewVacation();
                onClose();
            }
            else {
                setAlertMessage('დაფიქსირდა შეცდომა');
                setAlertSeverity('error');
                setAlertOpen(true);
                onNewVacation();
                onClose();
            }


        } catch (error) {
            console.error('Failed to create vacation:', error);
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertSeverity('error');
            setAlertOpen(true);
        }
    };


    const handleCloseAlert = () => {
        setAlertOpen(false);
    };

    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
                <div style={{minHeight: 600}}>
                    <div className="user-id-container">
                        <MdPersonOutline size={24} color="#61DAFB"/>
                        <div>
                        <span style={{
                            fontWeight: 'bold',
                            color: '#333'
                        }}>არჩეული თანამშრომელი:</span> {getUserById(users, userId)}
                        </div>
                    </div>

                    <DialogContent>
                        <Autocomplete
                            options={users.filter(user => user.id !== userId)}
                            getOptionLabel={(option) => {
                                const isOnVacation = activeVacationUsers.some(vacationUser => vacationUser.onVacationUserId === option.id);
                                return `${option.firstName} ${option.lastName} - (${rolesInGeorgian[option.roleName]}) ${isOnVacation ? '(თანამშრომელი შვებულებაშია)' : ''}`;
                            }}
                            renderOption={(props, option) => {
                                const isOnVacation = activeVacationUsers.some(vacationUser => vacationUser.onVacationUserId === option.id);
                                return (
                                    <li {...props} style={{
                                        backgroundColor: isOnVacation ? '#f0f0f0' : 'white',
                                        color: isOnVacation ? 'grey' : 'black',
                                        pointerEvents: isOnVacation ? 'none' : 'auto',
                                        pointer: isOnVacation ? 'not-allowed' : 'pointer',

                                    }}>
                                        {`${option.firstName} ${option.lastName} - (${rolesInGeorgian[option.roleName]}) ${isOnVacation ? '(თანამშრომელი შვებულებაშია)' : ''}`}
                                    </li>
                                );
                            }} // Apply disabled styling
                            onChange={(event, value) => {
                                if (value) {
                                    const isOnVacation = activeVacationUsers.some(vacationUser => vacationUser.onVacationUserId === value.id);
                                    if (!isOnVacation) {
                                        handleUserChange(event, value); // Proceed only if not on vacation
                                    }
                                }
                            }}
                            renderInput={(params) => <TextField {...params} label="მოვალეობის შემსრულებელი" margin="normal"/>}
                            fullWidth
                        />

                    </DialogContent>
                    <div style={{display: "flex", gap: 60, marginLeft: 28}}>
                        <DatePicker
                            selected={vacationStartDate}
                            onChange={date => setVacationStartDate(date)}
                            locale={ka}
                            showMonthDropdown
                            showYearDropdown
                            minDate={new Date()}
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="დაწყების თარიღი"
                        />
                        <DatePicker
                            selected={vacationEndDate}
                            onChange={date => setVacationEndDate(date)}
                            locale={ka}
                            showMonthDropdown
                            showYearDropdown
                            minDate={vacationStartDate || new Date()}
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="დასასრულის თარიღი"
                        />
                    </div>
                </div>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        დახურვა
                    </Button>
                    <Button onClick={handleSubmit} color="primary" disabled={submitDisabled || selectedUserId === ''}>
                        გაგზავნა
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={alertOpen}
                autoHideDuration={6000}
                onClose={handleCloseAlert}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                sx={{width: '50%'}}
            >
                <Alert onClose={handleCloseAlert} severity={alertSeverity} sx={{width: '100%', fontSize: '1.2rem'}}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default VacationPopup;
